<template>
  <div class="header">
    <!-- <div class="icon-list" @click="toggleMsg">
      <img src="~assets/icon_meaasge.png"  class="icon-meaasge" alt="">
      消息
    </div> -->
    <el-button class="out-btn" @click="loginOut">退出</el-button>
    <ul class="message-container" v-if="msgs.length > 0 && msgShow">
      <li class="msg-list" v-for="(item, index) in msgs" :key="index">
        <p class="msg">{{item.message}}</p>
        <p class="msg-date">{{item.date}}</p>
      </li>
    </ul>
  </div>
</template>

<script type='text/ecmascript-6'>
import { delCookie } from 'common/js/mUtils.js'
export default {
  data () {
    return {
      msgs: [],
      msgShow: false
    }
  },
  created () {
    // this.initData()
  },
  methods: {
    initData() {
      let that = this;
      that.$api.getMessages({}).then(res=> {
        console.log(res)
        if (res.data.length > 0) {
          that.msgs = res.data
        }
      })
    },
    toggleMsg() {
      this.msgShow = !this.msgShow
    },
    loginOut() {
      let that = this
      that.$confirm('您确定要退出吗?', '退出管理平台', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        // 清除 cookie
        delCookie('u_uuid_userId')
        that.$router.push({ path: '/' });
        that.$message({
          type: 'success',
          message: '退出成功!',
          customClass: 'msg-position',
          showClose: true
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消退出',
          customClass: 'msg-position',
          showClose: true
        })
      })
    }
  }
}
</script>

<style  lang='stylus' rel='stylesheet/stylus'>
.header
  width: 100%;
  height:3rem;
  background:#fff;
  padding:0 1.5rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  box-shadow: 0rem 0.2rem 0.25rem #ddd;
  .icon-list
    color: #666;
    font-size:0.7rem;
    cursor: pointer;
    .icon-meaasge
      vertical-align:text-top;
  .out-btn
    margin-left: 0.4rem;
    height:1.6rem;
    padding:0.2rem 1rem;
    background: #1D489E;
    border-radius: 0.1rem;
    border:none;
    span
      color:#fff;
      font-size:0.7rem;
    &:hover
      background: #1D489E;
  .message-container
    position: fixed;
    top:3.1rem;
    right:1rem;
    width:15rem;
    background:#fff;
    z-index: 200;
    padding: 1rem;
    border: 0.05rem solid #d8d8d8;
    border-radius:0.2rem;
    .msg-list
      margin-top: 0.3rem;
      .msg
        color:#31323D;
        font-size:0.7rem;
      .msg-date
        color:#2a2a2a;
        font-size:0.6rem;
</style>
